(() => {
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function initGalleries() {
    $$('[data-gallery]').forEach((gallery) => {
      const images = $$('[data-gallery-image]', gallery);
      const thumbnails = $$('[data-gallery-thumbnail]', gallery);
      const currentLabel = gallery.querySelector('[data-gallery-current]');
      if (!images.length) return;
      let current = Math.max(0, images.findIndex((image) => !image.hidden));
      let touchStart = null;

      const show = (index) => {
        current = (index + images.length) % images.length;
        images.forEach((image, imageIndex) => { image.hidden = imageIndex !== current; });
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === current;
          thumbnail.classList.toggle('active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
        });
        if (currentLabel) currentLabel.textContent = String(current + 1);
        thumbnails[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };

      thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => show(index)));
      gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
      const stage = gallery.querySelector('.gf-main-image, .wl-main-image');
      stage?.addEventListener('touchstart', (event) => { touchStart = event.touches[0]?.clientX ?? null; }, { passive: true });
      stage?.addEventListener('touchend', (event) => {
        if (touchStart === null) return;
        const distance = touchStart - (event.changedTouches[0]?.clientX ?? touchStart);
        touchStart = null;
        if (Math.abs(distance) > 45) show(current + (distance > 0 ? 1 : -1));
      }, { passive: true });
      show(current);
    });
  }

  function initProduct() {
    $$('[data-product-root]').forEach((root) => {
      const productForm = root.querySelector('.gd-product-form');
      const variantInput = root.querySelector('[data-selected-variant]');
      const addButton = root.querySelector('[data-add-button]');
      const mobileButton = root.querySelector('[data-mobile-add]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const restockPanel = root.querySelector('[data-restock-panel]');
      const restockInput = root.querySelector('[data-restock-email]');
      const restockError = root.querySelector('[data-restock-error]');
      const restockSuccess = root.querySelector('[data-restock-success]');
      const restockForm = root.querySelector('[data-restock-form]');
      let selectedVariant = null;
      let restockVariant = null;

      function setButtonLabel(button, text, price) {
        button.textContent = '';
        button.append(document.createTextNode(text));
        if (price) {
          const span = document.createElement('span');
          span.textContent = `${price} →`;
          button.append(span);
        }
      }

      $$('[data-variant-button]', root).forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.available !== 'true') {
            restockVariant = { id: button.dataset.variantId, title: button.dataset.variantTitle };
            root.querySelector('[data-restock-size]').textContent = restockVariant.title;
            root.querySelector('[data-restock-success-size]').textContent = restockVariant.title;
            restockPanel.hidden = false;
            restockForm.hidden = false;
            restockSuccess.hidden = true;
            restockError.hidden = true;
            setTimeout(() => restockInput?.focus(), 0);
            return;
          }

          selectedVariant = { id: button.dataset.variantId, title: button.dataset.variantTitle, price: button.dataset.variantPrice };
          $$('[data-variant-button]', root).forEach((item) => item.classList.toggle('selected', item === button));
          variantInput.value = selectedVariant.id;
          addButton.disabled = false;
          addButton.classList.remove('gf-add-disabled');
          setButtonLabel(addButton, `Add size ${selectedVariant.title} to bag `, selectedVariant.price);
          if (mobileButton) mobileButton.textContent = 'Add to bag';
          if (mobilePrice) mobilePrice.textContent = `Size ${selectedVariant.title} · ${selectedVariant.price}`;
          restockPanel.hidden = true;
        });
      });

      root.querySelector('[data-restock-close]')?.addEventListener('click', () => { restockPanel.hidden = true; });
      root.querySelector('[data-restock-submit]')?.addEventListener('click', async () => {
        if (!restockInput?.value.trim()) {
          restockInput.setCustomValidity('Enter your email address.');
          restockInput.reportValidity();
          restockInput.setCustomValidity('');
          return;
        }
        if (!restockInput.checkValidity()) { restockInput.reportValidity(); return; }
        const button = root.querySelector('[data-restock-submit]');
        button.disabled = true;
        button.textContent = 'ADDING…';
        restockError.hidden = true;
        try {
          const response = await fetch('https://alertmerestockalerts.herokuapp.com/addemail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: restockInput.value,
              store: 'simply-stitchd.myshopify.com',
              product: root.dataset.productId,
              variant: restockVariant.id,
              url: `/products/${root.dataset.productHandle}`,
              ajax: 'true', firstName: '', lastName: '', daAcceptsMarketing: ''
            })
          });
          if (!response.ok) throw new Error('Signup failed');
          restockForm.hidden = true;
          restockSuccess.hidden = false;
        } catch (_) {
          restockError.hidden = false;
          button.disabled = false;
          button.textContent = 'NOTIFY ME →';
        }
      });

      mobileButton?.addEventListener('click', () => {
        if (selectedVariant && productForm) productForm.requestSubmit();
        else document.querySelector(mobileButton.dataset.target)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      productForm?.addEventListener('submit', () => {
        if (!selectedVariant || productForm.dataset.submitting === 'true') return;
        productForm.dataset.submitting = 'true';
        addButton.disabled = true;
        addButton.classList.add('gf-add-confirmed');
        setButtonLabel(addButton, 'Added! Opening your bag…');
        if (mobileButton) {
          mobileButton.disabled = true;
          mobileButton.classList.add('gf-add-confirmed');
          mobileButton.textContent = 'Added!';
        }
      });

    });
  }

  function initFitFinder() {
    const root = document.querySelector('[data-fit-finder]');
    if (!root) return;
    const rows = [
      { jean: 24, us: 0, waist: 28, hip: 34 }, { jean: 25, us: 2, waist: 29, hip: 35 },
      { jean: 26, us: 4, waist: 30, hip: 36 }, { jean: 27, us: 4, waist: 31, hip: 37 },
      { jean: 28, us: 6, waist: 32, hip: 38 }, { jean: 29, us: 8, waist: 33, hip: 39 },
      { jean: 30, us: 10, waist: 34, hip: 40 }, { jean: 31, us: 12, waist: 34.5, hip: 41.5 },
      { jean: 32, us: 14, waist: 35, hip: 43 }, { jean: 33, us: 16, waist: 35.5, hip: 44.5 },
      { jean: 34, us: 16, waist: 36, hip: 45 }
    ];
    const waistInput = root.querySelector('[data-fit-waist]');
    const hipInput = root.querySelector('[data-fit-hip]');
    const message = root.querySelector('[data-fit-message]');
    const messageText = root.querySelector('[data-fit-message-text]');
    const result = root.querySelector('[data-fit-result]');

    const updateEmail = (match = null) => {
      const waist = waistInput.value || '___';
      const hip = hipInput.value || '___';
      const subject = encodeURIComponent('Help me find my g+d size');
      const suggestion = match ? ` The fit finder suggested size ${match.jean}.` : '';
      const body = encodeURIComponent(`Hi! My waist is ${waist} inches and my hips are ${hip} inches.${suggestion} Can you help me choose my best size?`);
      $$('[data-fit-email]').forEach((link) => { link.href = `mailto:team@gingeranddandelion.com?subject=${subject}&body=${body}`; });
    };

    root.querySelector('[data-fit-submit]').addEventListener('click', () => {
      const waist = Number(waistInput.value);
      const hip = Number(hipInput.value);
      message.hidden = true;
      result.hidden = true;
      $$('[data-size-row]').forEach((row) => { row.classList.remove('recommended-row'); row.querySelector('[data-fit-match]').hidden = true; });
      if (!waist || !hip) {
        messageText.textContent = 'Add both measurements so we can find your starting size.';
        message.hidden = false;
        updateEmail();
        return;
      }
      if (waist < 25 || waist > 40 || hip < 31 || hip > 49) {
        messageText.textContent = 'Your measurements fall outside this chart. Send them to us and we’ll help personally.';
        message.hidden = false;
        updateEmail();
        return;
      }
      const match = [...rows].sort((a, b) => (Math.abs(a.hip - hip) * 1.45 + Math.abs(a.waist - waist)) - (Math.abs(b.hip - hip) * 1.45 + Math.abs(b.waist - waist)))[0];
      root.querySelector('[data-fit-result-size]').textContent = match.jean;
      root.querySelector('[data-fit-result-us]').textContent = match.us;
      root.querySelector('[data-fit-result-waist]').textContent = match.waist;
      root.querySelector('[data-fit-result-hip]').textContent = match.hip;
      root.querySelector('[data-fit-result-size-text]').textContent = match.jean;
      const row = document.querySelector(`[data-size-row="${match.jean}"]`);
      row?.classList.add('recommended-row');
      if (row?.querySelector('[data-fit-match]')) row.querySelector('[data-fit-match]').hidden = false;
      result.hidden = false;
      updateEmail(match);
    });
    [waistInput, hipInput].forEach((input) => input.addEventListener('input', () => updateEmail()));
    updateEmail();
  }

  function initCollectionFilters() {
    const toolbar = document.querySelector('[data-collection-toolbar]');
    const grid = document.querySelector('[data-collection-grid]');
    if (!toolbar || !grid) return;
    const cards = $$('[data-fit]', grid);
    $$('[data-collection-filter]', toolbar).forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.collectionFilter;
      cards.forEach((card) => { card.hidden = filter !== 'all' && card.dataset.fit !== filter; });
      $$('[data-collection-filter]', toolbar).forEach((item) => item.classList.toggle('active', item === button || (filter === 'all' && item.dataset.collectionFilter === 'all')));
      const count = cards.filter((card) => !card.hidden).length;
      toolbar.querySelector('[data-visible-style-count]').textContent = String(count);
    }));
  }

  function initWideInterest() {
    const root = document.querySelector('[data-wide-leg-root]');
    if (!root) return;
    $$('[data-wide-interest-form]', root).forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button');
      const error = form.querySelector('[data-interest-error]');
      const success = form.nextElementSibling;
      if (!input.checkValidity()) { input.reportValidity(); return; }
      button.disabled = true;
      button.textContent = 'ADDING YOUR VOTE…';
      error.hidden = true;
      try {
        const response = await fetch('https://alertmerestockalerts.herokuapp.com/addemail', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: input.value, store: 'simply-stitchd.myshopify.com', product: root.dataset.productId, variant: root.dataset.variantId, url: `/products/${root.dataset.productHandle}`, ajax: 'true', firstName: '', lastName: '', daAcceptsMarketing: '' })
        });
        if (!response.ok) throw new Error('Signup failed');
        form.hidden = true;
        success.hidden = false;
      } catch (_) {
        error.hidden = false;
        button.disabled = false;
        button.textContent = 'VOTE IT INTO PRODUCTION →';
      }
    }));
  }

  function loadStamped() {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (window.StampedFn?.loadWidgets) { window.StampedFn.loadWidgets(); window.clearInterval(timer); }
      else if (attempts > 20) window.clearInterval(timer);
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initGalleries();
    initProduct();
    initFitFinder();
    initCollectionFilters();
    initWideInterest();
    loadStamped();
  });
})();
